import Logo from "./Logo";
import NavButton from "./NavButton";
import NavigatorButtons from "./NavigatorButtons";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { setActiveSection } from "../../store";
import { useState } from "react";

function TopNav({
  className,
  aboutRef,
  worksRef,
  experienceRef,
  contactRef,
  mainDivRef,
  preventIntersectionObserver,
}) {
  const dispatch = useDispatch();
  const { activeSection } = useSelector((store) => store.app);
  const [menuOpen, setMenuOpen] = useState(false);

  function scrollToTargetAdjusted(ref) {
    const headerOffset = 55;
    const elementPosition = ref.current.getBoundingClientRect().top;
    const offsetPosition =
      elementPosition + mainDivRef.current.scrollTop - headerOffset;

    mainDivRef.current.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }

  return (
    <div
      className={classNames("h-[60px] w-full bg-transparent z-50", className)}
    >
      <div className="h-max w-max pm-nav-background rounded-ee px-1 absolute top-0 left-0">
        <Logo />
      </div>
      <div className="h-[52px] aspect-square absolute right-4 top-2 ps-nav-shadow">
        <div
          className={classNames(
            "h-full w-full yellow-bg flex flex-col justify-center items-center cursor-pointer",
            {
              rounded: !menuOpen,
              "rounded-t": menuOpen,
            }
          )}
          onClick={() => {
            setMenuOpen(!menuOpen);
          }}
        >
          {!menuOpen && (
            <svg
              width="25"
              height="20"
              viewBox="0 0 25 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 18.25H24"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M1 9.625H24"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M1 1H24"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          )}

          {menuOpen && (
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 23L23 1"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M1 1L23 23"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>
        {menuOpen && (
          <div className="ps-nav-shadow h-max w-[90vw] yellow-bg rounded rounded-tr-none overflow-hidden absolute right-0 top-[52px]">
            <NavigatorButtons>
              <NavButton
                text="About"
                selected={activeSection === "about"}
                onClick={() => {
                  setMenuOpen(false);
                  dispatch(setActiveSection("about"));
                  preventIntersectionObserver.current = true;
                  scrollToTargetAdjusted(aboutRef);
                  setTimeout(() => {
                    preventIntersectionObserver.current = false;
                  }, 300);
                }}
              />
              <NavButton
                text="Works"
                selected={activeSection === "works"}
                onClick={() => {
                  setMenuOpen(false);
                  dispatch(setActiveSection("works"));
                  preventIntersectionObserver.current = true;
                  scrollToTargetAdjusted(worksRef);
                  setTimeout(() => {
                    preventIntersectionObserver.current = false;
                  }, 300);
                }}
              />
              <NavButton
                text="Experience"
                selected={activeSection === "experience"}
                onClick={() => {
                  setMenuOpen(false);
                  dispatch(setActiveSection("experience"));
                  preventIntersectionObserver.current = true;
                  scrollToTargetAdjusted(experienceRef);
                  setTimeout(() => {
                    preventIntersectionObserver.current = false;
                  }, 300);
                }}
              />
              <NavButton
                text="Contact"
                selected={activeSection === "contact"}
                onClick={() => {
                  setMenuOpen(false);
                  dispatch(setActiveSection("contact"));
                  preventIntersectionObserver.current = true;
                  scrollToTargetAdjusted(contactRef);
                  setTimeout(() => {
                    preventIntersectionObserver.current = false;
                  }, 300);
                }}
              />
            </NavigatorButtons>
          </div>
        )}
      </div>
    </div>
  );
}

export default TopNav;
